module.exports = __webpack_public_path__ + "static/img/smail.2eb18d04.png";